<template>
  <LocationList/>
</template>

<script>
import LocationList from '@/components/Locations/LocationList.vue';

export default {
  components: {
    LocationList,
  },
};
</script>
